import React from 'react'
import Heading from '../../../../../components/heading/Heading'
import { HEADING } from '../../../../../components/heading/constants/constants'
import TextInput from '../../../../../components/input/textinput/TextInput'
import ErrorsList from '../../../../../components/input/errorslist/ErrorsList'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setRecipientBasicInformation, setTinNotProviderState } from '../../AddRecipientSlice'
import Payer from '../../../../../../libs/utility/Payer'
import commonStyles from "../../AddRecipient.styles"
import styles from "./GetBasicInfo.styles"
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator'
import CheckboxWLabel from '../../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import { RECIPIENT_TYPE_TITLE } from '../../getrecipienttype/constants'
import Recipient from '../../../../../../libs/utility/Recipient'
import General from '../../../../../../libs/utility/General'
import { RECIPIENT_PHONE_NUM_FIELD_NAME } from '../../constant'

export default function GetBasicInfo({renderForSingleView = false}) {

    const { recipientBasicInfo, RecipientType, RequestType } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setRecipientBasicInformation({ [name]: { value, errors, rules } }));
        }
        else {
            dispatch(setRecipientBasicInformation({ [name]: { value } }));
        }
    };

    const validateData = (event, rules) => {
        General.validateInputWithRegex(event, () => onChangehandler(event, rules))
    }

    const { tinTooltip, tinPlaceholder, tinValue, tinRules, showNames, tinDisabled } = Recipient.getTINProps(RecipientType, recipientBasicInfo.RecipientTIN?.value, RequestType, recipientBasicInfo?.tinNotProvided);

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>Can you tell us more about this recipient?</Heading>
                    <p>This information is required by the IRS. Let's fill this out quickly and
                    move on.</p>
                </div>

                <div style={commonStyles.formContainer}>
                    <div>
                        <div style={styles.formRow}>
                            <div style={styles.payersNameContainer}>

                                {showNames &&
                                    (<>
                                        <TextInput
                                            name="RecipientFirstName"
                                            label="First Name"
                                            placeHolder='First Name'
                                            value={recipientBasicInfo.RecipientFirstName.value}
                                            onChangeCb={onChangehandler}
                                            rules={{ ...recipientBasicInfo?.RecipientFirstName?.rules }}
                                            formSubmitted={recipientBasicInfo?.allRequiredFieldsTouched}
                                            errors={recipientBasicInfo?.RecipientFirstName?.errors}
                                        />
                                        <div style={styles.recipientsMiddleNameContainer}>
                                            <TextInput
                                                name="RecipientMiddleName"
                                                label='Middle Name'
                                                placeHolder='Middle Name'
                                                value={recipientBasicInfo?.RecipientMiddleName?.value}
                                                onChangeCb={onChangehandler}
                                                rules={{ ...recipientBasicInfo?.RecipientMiddleName?.rules }}
                                                formSubmitted={recipientBasicInfo?.allRequiredFieldsTouched}
                                                errors={recipientBasicInfo?.RecipientMiddleName?.errors}
                                            />
                                        </div>
                                    </>)}

                                {showNames && <TextInput
                                    label={showNames ? "Last Name" : "Business Name"}
                                    name="RecipientLastName"
                                    placeHolder={showNames ? "Last Name" : "Enter business name"}
                                    value={recipientBasicInfo?.RecipientLastName?.value}
                                    onChangeCb={onChangehandler}
                                    rules={recipientBasicInfo?.RecipientLastName?.rules}
                                    formSubmitted={recipientBasicInfo?.allRequiredFieldsTouched}
                                    errors={recipientBasicInfo?.RecipientLastName?.errors}
                                />
                                }
                            </div>
                        </div>
                    </div>
                    <div style={styles.formRow}>
                        <div style={styles.recipientFieldsContainer}>
                            <div style={styles.recipientBatch3Container}>
                                <TextInput
                                    name="RecipientTIN"
                                    type="text"
                                    labelWTooltip={tinTooltip}
                                    placeHolder={tinPlaceholder}
                                    value={tinValue}
                                    onChangeCb={onChangehandler}
                                    rules={recipientBasicInfo?.RecipientTIN?.rules}
                                    errors={recipientBasicInfo?.RecipientTIN?.errors}
                                    formSubmitted={recipientBasicInfo?.allRequiredFieldsTouched}
                                    disabled={recipientBasicInfo?.tinNotProvided || tinDisabled}
                                />
                            </div>
                            <CheckboxWLabel
                                checked={recipientBasicInfo.tinNotProvided}
                                label="TIN not provided"
                                name="tinNotProvided"
                                onChangeCb={(e) => dispatch(setTinNotProviderState(e.target.checked))}
                                containerCustomStyle= {styles.tinNotProvidedContainer}
                                labelCustomStyles= {styles.tinNotProvidedLabelContainer}
                            />

                            <div style={styles.recipientBatch2Container}>
                                {!showNames && <TextInput
                                    label={showNames ? "Last Name" : "Business Name"}
                                    name="RecipientLastName"
                                    placeHolder={showNames ? "Last Name" : "Enter business name"}
                                    value={recipientBasicInfo?.RecipientLastName?.value}
                                    onChangeCb={onChangehandler}
                                    rules={recipientBasicInfo?.RecipientLastName?.rules}
                                    formSubmitted={recipientBasicInfo?.allRequiredFieldsTouched}
                                    errors={recipientBasicInfo?.RecipientLastName?.errors}
                                />
                                }
                            </div>
                        </div>
                    </div>
                    <div style={styles.formRow}>
                        <div style={styles.recipientFieldsContainer}>
                            <div style={styles.recipientBatch1Container}>
                                <TextInput
                                    name="RecipientEmail"
                                    type="email"
                                    label="Email Address"
                                    placeHolder='abc@example.com'
                                    value={recipientBasicInfo.RecipientEmail?.value}
                                    onChangeCb={onChangehandler}
                                    rules={recipientBasicInfo.RecipientEmail?.rules}
                                    errors={recipientBasicInfo.RecipientEmail.errors}
                                    formSubmitted={recipientBasicInfo.allRequiredFieldsTouched}
                                />
                            </div>

                            <div style={styles.recipientBatch2Container}>
                                <TextInput
                                    label="Phone Number"
                                    name={RECIPIENT_PHONE_NUM_FIELD_NAME}
                                    placeHolder="(201) 555-0123"
                                    type="text"
                                    value={recipientBasicInfo.RecipientPhNo?.value}
                                    onChangeCb={validateData}
                                    rules={{ ...recipientBasicInfo.RecipientPhNo?.rules }}
                                    errors={recipientBasicInfo.RecipientPhNo.errors}
                                    formSubmitted={recipientBasicInfo.allRequiredFieldsTouched}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
